var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningsvgrIcon = function SvgWarningsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.943 3.336c.408.191.739.502.943.884l5.89 11.046c.522.977.1 2.164-.942 2.652a2.2 2.2 0 0 1-.943.209H4.109C2.944 18.127 2 17.242 2 16.15c0-.307.076-.61.223-.884L8.113 4.22c.522-.976 1.788-1.372 2.83-.884M10 14.127a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8a1 1 0 0 0-.993.883L9 7.127v4a1 1 0 0 0 1.993.117l.007-.117v-4a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningsvgrIcon);
export default ForwardRef;